module.exports = __webpack_public_path__ + "img/spadegaming.f45e518c.png";